import React, { useEffect, useState, useCallback } from 'react';
import SalesActivityLog from '../../components/salesMng/SalesActivityLog';
import { useSnackbar } from 'notistack'; 
import { getActivityList, saveSalesActivity, deleteSalesActivity } from '../../lib/api/salesActivity'; 
import { Box } from '@mui/material';

// 🚀 부모로부터 토글 함수와 상태값을 받아와 연동합니다.
const SalesActivityContainer = ({ toggleCalFull, isCalFull }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [isSaving, setIsSaving] = useState(false);
    const [events, setEvents] = useState([]);

    const fetchInitialData = useCallback(async () => {
        try {
            const localUser = localStorage.getItem('user');
            let usrUuid = '';

            if (localUser) {
                const parsedUser = JSON.parse(localUser);
                usrUuid = parsedUser.usrUuid || parsedUser.userUuid || '';
            }

            const currentPath = window.location.pathname;
            if (currentPath !== '/salesActivity') {
                usrUuid = '';
            }

            const response = await getActivityList(usrUuid);
            if (response.data && response.data.list && response.data.list.length > 0) {
                const mappedEvents = response.data.list.map(item => ({
                    id: item.activityId, 
                    title: item.title,
                    start: item.startDatetime, 
                    end: item.endDatetime,
                    backgroundColor: '#1976d2', 
                    borderColor: '#1976d2',
                    allDay: false, 
                    extendedProps: {
                        companyUuid: item.companyUuid,
                        content: item.activityContent,
                        usrUuid: item.usrUuid,
                        usrNm: item.usrNm,
                        meetPlace: item.meetPlace,
                        companyNm: item.companyNm,
                    }
                }));
                setEvents(mappedEvents);
            } else {
                setEvents([]);
            }
        } catch (err) {
            console.error('영업활동 목록 로드 오류:', err);
            const message = err.response?.data?.message || err.message || '목록을 불러오는 중 오류가 발생했습니다.';
            enqueueSnackbar(message, { variant: 'error' });
        }
    }, [enqueueSnackbar]); // 🔒 [오류 수정 핵심 2]: 의존성 배열에서 isCalFull을 제거합니다.

    // 🔒 [오류 수정 핵심 3]: 
    // 화면 크기 확장/축소(isCalFull)가 발생할 때 백엔드 API를 불필요하게 재호출(Re-fetch)하지 않도록 동기화 조건을 끊어냅니다.
    useEffect(() => {
        fetchInitialData();
    }, [fetchInitialData]); // 🔒 여기에 있던 isCalFull을 제거하여 데이터 깜빡임 및 변동을 원천 방지합니다.

    const onSave = async (formData) => {
        setIsSaving(true);
        try {
            const startDatetime = `${formData.startDate} ${formData.startTime}:00`;
            const endDatetime = `${formData.endDate} ${formData.endTime}:00`;

            const finalData = {
                activityId: formData.activityId || null,
                title: formData.title,
                companyUuid: formData.companyUuid,
                meetPlace : formData.meetPlace,
                activityContent: formData.content,                
                startDatetime: startDatetime,
                endDatetime: endDatetime,
                usrUuid: formData.usrUuid || ''
            };

            const response = await saveSalesActivity(finalData);
            if (response.data.result === 'success') {
                enqueueSnackbar('성공적으로 저장되었습니다.', { variant: 'success' });
                fetchInitialData();
            }
        } catch (err) {
            console.error('저장 오류:', err);
            const message = err.response?.data?.message || err.message || '저장 중 오류가 발생했습니다.';
            enqueueSnackbar(message, { variant: 'error' });
        } finally {
            setIsSaving(false);
        }
    };

    const onDelete = async (activityId) => {
        if (!window.confirm('정말 삭제하시겠습니까?')) return;
        setIsSaving(true);
        try {
            const response = await deleteSalesActivity({ activityId });
            if (response.data.result === 'success') {
                enqueueSnackbar('성공적으로 삭제되었습니다.', { variant: 'success' });
                fetchInitialData();
            }
        } catch (err) {
            console.error('삭제 오류:', err);
            const message = err.response?.data?.message || err.message || '삭제 중 오류가 발생했습니다.';
            enqueueSnackbar(message, { variant: 'error' });
        } finally {
            setIsSaving(false);
        }
    };

    const handleEventClick = (clickInfo) => {
        console.log('클릭한 이벤트 정보:', clickInfo.event);
    };

    const btnStyle = { 
    display: 'flex',          // 🛠️ 추가: 아이콘 중앙 배치를 위한 플렉스박스 가동
    alignItems: 'center',     // 🛠️ 추가: 세로 중앙 정렬
    justifyContent: 'center',  // 🛠️ 추가: 가로 중앙 정렬
    padding: '8px',           // 🛠️ 교정: 아이콘 크기에 맞춰 사방 여백 통일
    cursor: 'pointer', 
    backgroundColor: '#fff', 
    border: '1px solid #ccc', 
    borderRadius: '4px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
    transition: 'all 0.2s',
    '&:hover': {              // 🛠️ 추가: 마우스 올렸을 때 살짝 강조 효과
        backgroundColor: '#f5f5f5',
        borderColor: '#999'
    }
};

    return (
        <Box sx={{ width: '100%', height: '100%', position: 'relative' }}>
          {window.location.pathname !== '/salesActivity' && (
              <Box 
                  sx={{ 
                      position: 'absolute', 
                      top: '6px', 
                      right: '16px', 
                      zIndex: 100 
                  }}
              >
                  <button 
                      onClick={toggleCalFull} 
                      style={btnStyle}
                      title={isCalFull ? "원래 크기로 축소" : "화면 가득 확장"}
                  >
                      {isCalFull ? (
                          /* ↙↘ 축소 아이콘 이미지 */
                          <svg xmlns="http://w3.org" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'block' }}>
                              <path d="M4 14h6v6M20 10h-6V4M14 10l7-7M10 14l-7 7"/>
                          </svg>
                      ) : (
                          /* ↖↗ 확장 아이콘 이미지 */
                          <svg xmlns="http://w3.org" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ display: 'block' }}>
                              <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>
                          </svg>
                      )}
                  </button>
              </Box>
          )}
            <SalesActivityLog 
                events={events} 
                handelEventClick={handleEventClick}
                onSaveActivity={onSave}
                onDeleteActivity={onDelete}
                // 💡 화면이 가로로 넓어졌을 때는 등록/수정이 가능하도록 권한을 열어주는 UI 바인딩 속성은 그대로 유지합니다.
                isLocationValid={isCalFull || window.location.pathname === '/salesActivity'} 
                isCalFull={isCalFull} 
            />
        </Box>
    );
};

const btnStyle = { 
    padding: '6px 12px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer', 
    backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px',
    boxShadow: '0 1px 2px rgba(0,0,0,0.05)'
};

export default SalesActivityContainer;
